import type { LoaderFunctionArgs } from 'react-router'
import { redirect, useLoaderData } from 'react-router'
import { useRef } from 'react'

import { StickyHeader } from '@components/header'
import { Page } from '@components/page'

import { CallToAction } from './call-to-action'
import { Feature } from './feature-slideshow'
import Footer from './footer'
import { Hero } from './hero'

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const { env } = await import('@config')
  const { landingPageImages } = await import('@content/images')
  const url = new URL(request.url)

  if (url.searchParams.get('shop')) {
    throw redirect(`/app?${url.searchParams.toString()}`)
  }

  return {
    images: landingPageImages,
    shopifyStoreLink: env.SHOPIFY_STORE_LINK
  }
}

export default function Landing() {
  const { images, shopifyStoreLink } = useLoaderData<typeof loader>()
  const containerRef = useRef<HTMLElement>(null)
  return (
    <Page ref={containerRef}>
      <StickyHeader
        callToActionLink={shopifyStoreLink}
        containerRef={containerRef}
        appIcon={images.appIcon}
      />
      <Hero callToActionLink={shopifyStoreLink} images={images} />
      <Feature collapseDelay={5000} linePosition='left' images={images} />
      {shopifyStoreLink && <CallToAction callToActionLink={shopifyStoreLink} />}
      <Footer />
    </Page>
  )
}
